import { render, staticRenderFns } from "./ButtonLabel.vue?vue&type=template&id=792acc5d&"
import script from "./ButtonLabel.vue?vue&type=script&lang=js&"
export * from "./ButtonLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports